import { productList } from '../item-listing/productList';
import productsApiClient from './ProductsApiClient';
export function getProductUrl(parentUrl, product) {
    return `${parentUrl}${product.relativeUrl}`;
}
export function categoryProductList(data, viewType) {
    return {
        ...productList(data, viewType),
        getProductUrl,
        // replacing apiSearch of productList
        async apiSearch(filterData, abort) {
            return await productsApiClient.search(filterData, abort);
        },
    };
}
